<template>
  <label
    class="d-flex align-items-center radio-button-label"
    @click="handleClick"
  >
    <input
      :id="radioValue.toString()"
      :checked="checked"
      :value="radioValue"
      type="radio"
    />
    <div class="d-flex align-items-center">
      <div :class="['radio-target', { checked }]"></div>
      <slot name="label">
        <span v-if="label" class="radio-label">{{ label }}</span>
      </slot>
      <slot></slot>
    </div>
  </label>
</template>

<script setup lang="ts">
import { computed } from "vue";

const emit = defineEmits(["update:modelValue"]);
const props = defineProps<{
  modelValue: string | number | boolean;
  radioValue: string | number | boolean;
  label?: string;
}>();

const checked = computed(() => props.modelValue === props.radioValue);

const handleClick = () => {
  emit("update:modelValue", props.radioValue);
};
</script>

<style lang="scss" scoped>
.radio-button-label {
  cursor: pointer;
  input {
    opacity: 0;
    height: 0;
    width: 0;
  }
  .radio-target {
    background-color: #fff;
    display: block;
    width: 1.5em;
    height: 1.5em;
    border-radius: 50%;
    border: 0.1em solid var(--gray-border-color);
    margin-right: 5px;
    &.checked {
      background: radial-gradient(
        #fff 25%,
        var(--sera-color-core-blue-mid-blue-500) 28%
      );
      border-color: var(--sera-color-core-blue-mid-blue-500);
    }
  }
  .radio-label {
    min-width: 50px;
  }
}
</style>
